import { useState } from "react";
import { Menu, X } from "lucide-react";
import { site } from "../content/site";
import { handleAnchorClick } from "../lib/scroll";
import { Logo } from "./Logo";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const onNavClick = (e, href) => {
    handleAnchorClick(e, href);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-white" data-testid="navbar">
      <nav
        className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8"
        aria-label="Main navigation"
      >
        <a
          href="#top"
          data-testid="nav-logo-link"
          onClick={(e) => onNavClick(e, "#top")}
          className="rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
          aria-label="Banga Pay home"
        >
          <Logo />
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {site.nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={item.testid}
              onClick={(e) => onNavClick(e, item.href)}
              className="rounded-sm text-sm font-medium text-gray-600 transition-colors duration-200 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#download"
            data-testid="nav-get-started-button"
            onClick={(e) => onNavClick(e, "#download")}
            className="rounded-md bg-brand px-4 py-2 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
          >
            Get Started
          </a>
        </div>

        <button
          type="button"
          data-testid="nav-mobile-menu-button"
          className="rounded-md p-2 text-gray-700 hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand md:hidden"
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
        </button>
      </nav>

      {open && (
        <div id="mobile-menu" className="border-t border-gray-200 bg-white md:hidden" data-testid="nav-mobile-menu">
          <div className="space-y-1 px-4 py-4">
            {site.nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`${item.testid}-mobile`}
                onClick={(e) => onNavClick(e, item.href)}
                className="block rounded-md px-3 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#download"
              data-testid="nav-get-started-button-mobile"
              onClick={(e) => onNavClick(e, "#download")}
              className="mt-2 block rounded-md bg-brand px-3 py-2.5 text-center text-base font-semibold text-white hover:bg-brand-hover"
            >
              Get Started
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
